import Dialog from 'a11y-dialog-component/dist/a11y-dialog-component'

export const settings = {
  selector: '.js-modal',
  openBtn: '.js-modal-open',
  modal: '.js-modal-dialog',
  closeBtn: '.js-modal-close',
}

/**
 * Function initializes all elements in page.
 */
export default function initAll() {
  let elements = document.querySelectorAll( settings.selector )

  // Create modal container.
  const modal = document.createElement( 'div' )
  modal.classList.add( 'c-modal' )
  modal.classList.add( settings.modal.replace( '.', '' ))
  document.body.appendChild( modal )

  Array.from( elements ).forEach(( element ) => {
    init( element )
  })
}

/**
 * Function initializes single element.
 * @param {DOMNode} element
 */
export function init( element ) {
  const openBtn = element.querySelector( settings.openBtn )
  const url = openBtn.dataset.modalUrl
  openBtn.addEventListener( 'click', () => {
    fetch( url )
      .then(( response ) => response.text())
      .then(( text ) => {
        const parser = new DOMParser()
        const htmlDocument = parser.parseFromString( text, 'text/html' )
        const modalContent = htmlDocument.documentElement.querySelector( '.t-modal' )
        const modal = document.querySelector( settings.modal )
        modal.innerHTML = ''
        modal.appendChild( modalContent )
        const dialog = new Dialog( settings.modal, {
          openingSelector: settings.openBtn,
          closingSelector: settings.closeBtn,
          isModal: true
        })
        dialog.open()
        const closeBtn = modalContent.querySelector( settings.closeBtn )
        closeBtn.addEventListener( 'click', () => {
          modal.innerHTML = ''
          dialog.destroy()
        })
        // TODO init next/prev buttons.
      })
  })
}
